<template>
	<el-col class="h-100">
		<table-view class="search-bar" :scrId="scrId"></table-view>
	</el-col>
</template>

<script>
import TableView from '@qms/TabSample/Content/Table/TableView.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {
		TableView
	}
};
</script>

<style></style>
